/**
 * Inline sample data for all 11 Mutation Breeding analyses + reference
 * tables for the 4 companion tools (Pipeline, Crop DB, Variety Comparison,
 * DUS Guide). All data is in-memory — no external fetches.
 */

export const MUTATION_INLINE_SAMPLES = {
  // 1. Mutagenic Dose Response — wheat, 6 doses 0–0.5% EMS, 3 reps
  'mutation-dose-response': `Dose,Rep,Germination_percent,Survival_percent,Seedling_height,Pollen_sterility_percent
0,1,95,92,15.2,5
0,2,96,93,15.0,4
0,3,94,91,15.1,6
0.1,1,85,80,13.5,12
0.1,2,86,82,13.3,11
0.1,3,84,79,13.7,13
0.2,1,75,65,11.0,25
0.2,2,74,64,10.8,26
0.2,3,76,66,11.2,24
0.3,1,58,45,8.5,45
0.3,2,57,44,8.3,46
0.3,3,59,46,8.7,44
0.4,1,35,22,5.8,68
0.4,2,34,21,5.6,69
0.4,3,36,23,6.0,67
0.5,1,12,5,3.2,85
0.5,2,11,4,3.0,86
0.5,3,13,6,3.4,84`,

  // 2. LD50 and GR50 — rice, 8 doses Gamma 0–400 Gy
  'mutation-ld50-gr50': `Dose,Germination_percent,Survival_percent,Seedling_height_cm,Rootlet_length_cm
0,96,95,18.2,12.5
50,92,90,16.8,11.2
100,85,82,14.5,9.8
150,76,71,12.0,8.1
200,62,55,9.5,6.4
250,48,38,7.0,4.8
300,30,22,4.5,3.2
350,15,10,2.5,1.8
400,5,3,1.0,0.8`,

  // 3. Mutation Frequency
  'mutation-frequency': `Treatment,Mutants,Total_plants
Control,3,10000
EMS_0.2,45,5000
EMS_0.3,78,5000
EMS_0.4,112,5000
Gamma_200,52,5000
Gamma_300,91,5000
Gamma_400,135,5000`,

  // 4. Mutant Spectrum
  'mutation-spectrum': `Treatment,Mutant_type,Count
EMS,Chlorophyll,45
EMS,Morphological,28
EMS,Early_flowering,18
EMS,Dwarf,22
EMS,Sterile,8
Gamma,Chlorophyll,52
Gamma,Morphological,31
Gamma,Early_flowering,15
Gamma,Dwarf,25
Gamma,Sterile,12
NaN3,Chlorophyll,30
NaN3,Morphological,18
NaN3,Early_flowering,22
NaN3,Dwarf,15
NaN3,Sterile,5`,

  // 5. M2 Generation
  'mutation-m2-generation': `M2_family,Plant_No,Trait_value
F1,1,45.2
F1,2,46.1
F1,3,44.8
F1,4,45.5
F1,5,46.0
F2,1,52.3
F2,2,38.5
F2,3,51.8
F2,4,40.2
F2,5,53.0
F3,1,48.5
F3,2,48.7
F3,3,48.2
F3,4,48.9
F3,5,48.6
F4,1,35.1
F4,2,52.4
F4,3,38.2
F4,4,53.0
F4,5,36.5
F5,1,55.2
F5,2,55.5
F5,3,55.0
F5,4,55.3
F5,5,55.1`,

  // 6. Chlorophyll Mutation
  'mutation-chlorophyll': `Treatment,Total_seedlings,Albina,Xantha,Viridis,Chlorina,Pollen_sterility_percent
EMS_0.2,2000,8,5,3,2,25
EMS_0.3,2000,14,9,6,4,45
EMS_0.4,2000,22,13,8,6,65
Gamma_200,2000,10,6,4,3,30
Gamma_300,2000,17,11,7,5,48
Gamma_400,2000,26,15,10,7,68`,

  // 7. Quantitative Mutation
  'mutation-quantitative': `Treatment,Plant_height,Days_to_flower,Grain_yield
Control,85.2,98,42.5
Control,86.1,99,43.1
Control,84.8,97,41.8
Control,85.5,98,42.2
Control,85.0,97,42.8
M2_EMS0.2,78.5,95,39.5
M2_EMS0.2,82.1,101,44.2
M2_EMS0.2,75.2,93,37.8
M2_EMS0.2,88.5,105,45.1
M2_EMS0.2,80.3,96,41.5
M2_EMS0.3,72.5,93,36.2
M2_EMS0.3,85.1,103,45.5
M2_EMS0.3,68.9,90,33.5
M2_EMS0.3,91.2,107,46.8
M2_EMS0.3,76.8,95,39.2`,

  // 8. Mutation Rate
  'mutation-rate': `Treatment,Mutants,Total_plants,Generations
EMS_0.2,45,5000,1
EMS_0.3,78,5000,1
Gamma_200,52,5000,1
Gamma_300,91,5000,1`,

  // 9. Comparative Mutagen
  'mutation-comparative': `Mutagen,Dose,Mutation_frequency,Pollen_sterility_percent,Injury_percent
EMS,0.2,0.9,25,18
EMS,0.3,1.56,45,32
EMS,0.4,2.24,65,48
Gamma,200,1.04,30,22
Gamma,300,1.82,48,35
Gamma,400,2.70,68,52
NaN3,5,0.6,20,15
NaN3,10,1.1,35,25
NaN3,15,1.8,50,40`,

  // 10. M3 Progeny Test
  'mutation-m3-progeny': `M3_family,Plant_No,Trait_value,Control_mean
F1,1,60,48
F1,2,59.5,48
F1,3,60.3,48
F1,4,60.1,48
F1,5,59.8,48
F1,6,60.2,48
F1,7,59.9,48
F1,8,60.0,48
F2,1,30,48
F2,2,48,48
F2,3,32,48
F2,4,50,48
F2,5,29,48
F2,6,47,48
F2,7,31,48
F2,8,49,48
F2,9,33,48
F2,10,46,48
F2,11,30.5,48
F2,12,48.5,48
F2,13,49.2,48
F2,14,47.8,48
F2,15,48.7,48
F2,16,49.5,48
F3,1,38,48
F3,2,38.5,48
F3,3,37.8,48
F3,4,38.2,48
F3,5,38.0,48
F3,6,37.9,48
F3,7,38.1,48
F3,8,38.3,48
F4,1,52,48
F4,2,53,48
F4,3,51,48
F4,4,52.5,48
F4,5,52.2,48
F4,6,52.8,48
F4,7,51.5,48
F4,8,52.1,48`,

  // 11. Mutant Screening Index
  'mutation-screening-index': `Mutant_ID,Trait1_score,Trait2_score,Trait3_score,Weight1,Weight2,Weight3
M1,8,7,9,3,2,4
M2,6,9,5,3,2,4
M3,9,6,8,3,2,4
M4,7,8,7,3,2,4
M5,5,9,9,3,2,4
M6,8,8,8,3,2,4
M7,9,5,7,3,2,4
M8,6,7,9,3,2,4
M9,7,6,6,3,2,4
M10,4,8,5,3,2,4`,
};

export const MUTATION_SAMPLE_BANNERS = {
  'mutation-dose-response': 'Sample loaded — Wheat, 6 EMS doses (0–0.5%), 3 reps — Run Analysis!',
  'mutation-ld50-gr50': 'Sample loaded — Rice, 9 Gamma doses (0–400 Gy) — Run Analysis!',
  'mutation-frequency': 'Sample loaded — Control + 6 mutagen treatments — Run Analysis!',
  'mutation-spectrum': 'Sample loaded — 3 mutagens × 5 mutant categories — Run Analysis!',
  'mutation-m2-generation': 'Sample loaded — 5 M2 families × 5 plants each — Run Analysis!',
  'mutation-chlorophyll': 'Sample loaded — 6 treatments × 4 chlorophyll classes — Run Analysis!',
  'mutation-quantitative': 'Sample loaded — Control + 2 M2 EMS doses × 3 traits — Run Analysis!',
  'mutation-rate': 'Sample loaded — 4 mutagen × dose combinations — Run Analysis!',
  'mutation-comparative': 'Sample loaded — 3 mutagens × 3 doses — Run Analysis!',
  'mutation-m3-progeny': 'Sample loaded — 4 M3 families (true-breeding, 3:1, intermediate, shifted) — Run Analysis!',
  'mutation-screening-index': 'Sample loaded — 10 mutants × 3 traits + 3 weights — Run Analysis!',
};

// India Crop Mutation Database — 20 major Indian crops
export const INDIAN_CROP_MUTATION_DB = [
  { crop: 'Wheat', latin: 'Triticum aestivum', mutagen: 'EMS / Gamma', ld50: '0.3% EMS / 250 Gy', gr50: '0.25% / 200 Gy', freq: '0.12%', varieties: 'Sharbati Sonora (Gamma), NIAW-34, Pusa Shreshth', institute: 'IARI / BARC' },
  { crop: 'Rice', latin: 'Oryza sativa', mutagen: 'Gamma / EMS', ld50: '300 Gy / 0.25% EMS', gr50: '250 Gy', freq: '0.18%', varieties: 'TKM-6 (Gamma), Jagannath, Mahsuri Mut', institute: 'IRRI / CRRI' },
  { crop: 'Maize', latin: 'Zea mays', mutagen: 'Gamma / EMS', ld50: '300 Gy', gr50: '250 Gy', freq: '0.15%', varieties: 'HM-4, HM-9, Pusa Composite', institute: 'IARI / PAU' },
  { crop: 'Mustard', latin: 'Brassica juncea', mutagen: 'EMS / Gamma', ld50: '0.4% EMS / 800 Gy', gr50: '0.3% / 600 Gy', freq: '0.25%', varieties: 'TM-4, TM-17, Pusa Karishma', institute: 'BARC / IARI' },
  { crop: 'Chickpea', latin: 'Cicer arietinum', mutagen: 'Gamma / EMS', ld50: '300 Gy / 0.3% EMS', gr50: '200 Gy', freq: '0.22%', varieties: 'Pusa-547, BGM-547, Vijay', institute: 'ICRISAT / IARI' },
  { crop: 'Pigeonpea', latin: 'Cajanus cajan', mutagen: 'Gamma', ld50: '300 Gy', gr50: '250 Gy', freq: '0.20%', varieties: 'TAT-10 (Gamma), TT-401', institute: 'BARC / ICRISAT' },
  { crop: 'Mungbean', latin: 'Vigna radiata', mutagen: 'EMS / Gamma', ld50: '0.2% EMS / 400 Gy', gr50: '0.15%', freq: '0.30%', varieties: 'TAP-7 (Gamma), Co-4, TARM-1', institute: 'BARC / TNAU' },
  { crop: 'Urd bean', latin: 'Vigna mungo', mutagen: 'Gamma / EMS', ld50: '350 Gy / 0.25%', gr50: '300 Gy', freq: '0.18%', varieties: 'TAU-2 (Gamma), TU-94-2', institute: 'BARC' },
  { crop: 'Groundnut', latin: 'Arachis hypogaea', mutagen: 'Gamma / EMS', ld50: '250 Gy', gr50: '200 Gy', freq: '0.12%', varieties: 'TG-26 (Gamma), TG-37A, TG-51', institute: 'BARC / ICRISAT' },
  { crop: 'Soybean', latin: 'Glycine max', mutagen: 'Gamma / EMS', ld50: '300 Gy', gr50: '250 Gy', freq: '0.15%', varieties: 'Birsa Soybean-1, JS-335', institute: 'BAU / JNKVV' },
  { crop: 'Cotton', latin: 'Gossypium hirsutum', mutagen: 'Gamma', ld50: '200 Gy', gr50: '150 Gy', freq: '0.10%', varieties: 'MCU-10 (Gamma), SRT-1', institute: 'TNAU / CICR' },
  { crop: 'Sugarcane', latin: 'Saccharum spp.', mutagen: 'Gamma / EMS', ld50: 'N/A (vegetative)', gr50: '40 Gy', freq: '0.08%', varieties: 'Co-527, Co 86032', institute: 'ICAR-SBI / VSI' },
  { crop: 'Jute', latin: 'Corchorus spp.', mutagen: 'Gamma', ld50: '600 Gy', gr50: '500 Gy', freq: '0.15%', varieties: 'JRO-7835, Mut JRC-412', institute: 'CRIJAF' },
  { crop: 'Sesame', latin: 'Sesamum indicum', mutagen: 'EMS / Gamma', ld50: '0.3% EMS / 400 Gy', gr50: '0.2%', freq: '0.20%', varieties: 'TKG-22, Krishna (Gamma)', institute: 'IIOR / JNKVV' },
  { crop: 'Sunflower', latin: 'Helianthus annuus', mutagen: 'Gamma / EMS', ld50: '200 Gy', gr50: '150 Gy', freq: '0.14%', varieties: 'Morden, Co-2', institute: 'DOR / TNAU' },
  { crop: 'Potato', latin: 'Solanum tuberosum', mutagen: 'Gamma', ld50: '20 Gy (tubers)', gr50: '15 Gy', freq: '0.05%', varieties: 'Kufri Chipsona-1 (Mutant)', institute: 'CPRI' },
  { crop: 'Tomato', latin: 'Solanum lycopersicum', mutagen: 'EMS / Gamma', ld50: '0.5% EMS / 200 Gy', gr50: '0.3%', freq: '0.20%', varieties: 'Pusa Ruby M, Selection-22', institute: 'IARI' },
  { crop: 'Brinjal', latin: 'Solanum melongena', mutagen: 'Gamma', ld50: '100 Gy', gr50: '75 Gy', freq: '0.15%', varieties: 'Pusa Bindu, Annamalai', institute: 'IARI / TNAU' },
  { crop: 'Onion', latin: 'Allium cepa', mutagen: 'Gamma', ld50: '80 Gy', gr50: '60 Gy', freq: '0.12%', varieties: 'Pusa Madhavi, N-53', institute: 'IARI / NHRDF' },
  { crop: 'Black Pepper', latin: 'Piper nigrum', mutagen: 'Gamma (cuttings)', ld50: '10 Gy', gr50: '7 Gy', freq: '0.04%', varieties: 'Subhakara', institute: 'IISR' },
];

// Simplified DUS descriptors for mutant varieties under PPV&FR Act
export const DUS_MUTANT_DESCRIPTORS = [
  { group: 'Plant morphology', descriptors: [
    'Plant: growth habit (erect / semi-erect / spreading)',
    'Plant: height at maturity (cm)',
    'Plant: tiller / branch number',
    'Plant: pigmentation (anthocyanin presence)',
  ]},
  { group: 'Leaf', descriptors: [
    'Leaf: shape',
    'Leaf: color intensity (light / medium / dark green)',
    'Leaf: pubescence',
    'Leaf: waxiness',
  ]},
  { group: 'Inflorescence / Spike', descriptors: [
    'Spike / panicle: length',
    'Spike: density (lax / intermediate / dense)',
    'Awning: presence / absence and length',
    'Time to flowering / heading (days)',
  ]},
  { group: 'Seed / Grain', descriptors: [
    'Grain: color',
    'Grain: shape',
    'Grain: 1000-grain weight (g)',
    'Grain: protein / oil content (%)',
  ]},
  { group: 'Reaction', descriptors: [
    'Reaction to major biotic stresses (rust / blast / YMV)',
    'Reaction to major abiotic stresses (drought / salinity)',
    'Maturity group vs check variety',
    'Yield as % of national check',
  ]},
];
